import React from 'react'
import { Progress, Table, Typography } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { TStorageItemRS, TModuleOptions } from '../../../../models/storageModel'
import { groupItemsByCategory, TCategoryStockGroup } from '../../../../utils/reportUtils'
import { TExcelColumn } from '../../../../utils/excelExport'
import { textNumberFormater } from '../../../../utils'

const { Text } = Typography

interface StockByCategoryReportProps {
  data: TStorageItemRS[]
  categoryOptions: TModuleOptions[]
  loading?: boolean
}

export const categoryExcelColumns: TExcelColumn[] = [
  { header: 'Categoría', key: 'categoryName', width: 25 },
  { header: 'Nº Productos', key: 'itemCount', width: 14, format: 'number' },
  { header: 'Existencia Total', key: 'totalQuantity', width: 16, format: 'number' },
  { header: 'Valoración Costo Total', key: 'totalCostValuation', width: 20, format: 'money' },
  { header: '% Valor del Inventario', key: 'percentage', width: 18, format: 'percent' }
]

export function getCategoryExcelData(data: TStorageItemRS[], categoryOptions: TModuleOptions[]) {
  return groupItemsByCategory(data, categoryOptions)
}

export const StockByCategoryReport: React.FC<StockByCategoryReportProps> = ({
  data,
  categoryOptions,
  loading = false
}) => {
  const groupedData = groupItemsByCategory(data, categoryOptions)

  const columns: ColumnsType<TCategoryStockGroup> = [
    {
      title: '#',
      key: 'index',
      width: 50,
      render: (_, __, index) => index + 1
    },
    {
      title: 'Categoría',
      dataIndex: 'categoryName',
      key: 'categoryName',
      render: (text) => <strong>{text}</strong>
    },
    {
      title: 'Nº Productos',
      dataIndex: 'itemCount',
      key: 'itemCount',
      width: 140,
      align: 'right',
      sorter: (a, b) => a.itemCount - b.itemCount,
      render: (val) => textNumberFormater(val)
    },
    {
      title: 'Existencia Total',
      dataIndex: 'totalQuantity',
      key: 'totalQuantity',
      width: 160,
      align: 'right',
      sorter: (a, b) => a.totalQuantity - b.totalQuantity,
      render: (val) => <Text style={{ color: '#52c41a' }}>{textNumberFormater(val)}</Text>
    },
    {
      title: 'Valoración Costo Total',
      dataIndex: 'totalCostValuation',
      key: 'totalCostValuation',
      width: 200,
      align: 'right',
      sorter: (a, b) => a.totalCostValuation - b.totalCostValuation,
      render: (val) => <Text strong style={{ color: '#1890ff' }}>$ {textNumberFormater(val)}</Text>
    },
    {
      title: '% Valor del Inventario',
      dataIndex: 'percentage',
      key: 'percentage',
      width: 220,
      sorter: (a, b) => a.percentage - b.percentage,
      render: (pct) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Progress percent={pct} size="small" strokeColor="#722ed1" style={{ flex: 1, margin: 0 }} />
          <span style={{ width: 45, textAlign: 'right', fontSize: '0.85rem' }}>{pct}%</span>
        </div>
      )
    }
  ]

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <Table<TCategoryStockGroup>
        columns={columns}
        dataSource={groupedData}
        loading={loading}
        pagination={false}
        size="small"
        bordered
        scroll={{ x: 'max-content' }}
      />
    </div>
  )
}

export default StockByCategoryReport
